<template>

</template>

<script>

  import signoutMixin from '../mixins/signoutMixin'
  
  export default {
    mixins: [signoutMixin],
    created () {
      this.signout();
    }
  }

</script>


// WEBPACK FOOTER //
// src/components/Signout.vue